import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "../pages/Dashboard/Dashboard";
import UseLayout from "../components/Layout/Layout";
import Login from "../pages/Login/Login";
import CategoriesList from "../pages/Manage/CategoriesList/CategoriesList";
import ProductList from "../pages/Manage/ProductList/ProductList";
import { ProtectedRoute, SignInRoute } from "./ProtectedRoute";
import AddCategory from "../components/CategoriesComponents/AddCategory/AddCategory";
import SubCategoriesList from "../pages/Manage/SubCategoryList/SubCategoryList";
import AddProducts from "../components/ProductComponents/AddProducts/AddProducts";
import AddSubCategory from "../components/CategoriesComponents/AddSubCategory/AddSubCategory";
import Layer3Category from "../pages/Manage/Layer3Category/Layer3Category";
import AddLayer3Category from "../components/CategoriesComponents/AddLayer3Category/AddLayer3Category";
import CustomDashboard from "../pages/CustomDashboard/CustomDashboard";
import AddTopic from "../components/CustomDashboardComponents/AddTopic/AddTopic";
import ProductTopicItems from "../components/CustomDashboardComponents/ProductTopicItems/ProductTopicItems";
import CategoryTopicItems from "../components/CustomDashboardComponents/CategoryTopicItems/CategoryTopicItems";
import AddAdvertisementTopic from "../components/CustomDashboardComponents/AddAdvertisementTopic/AddAdvertisementTopic";
import CustomersList from "../pages/Customers/CustomersList";
import TrendingProducts from "../components/TrendingProducts/TrendingProducts";
import PopularCategories from "../components/PopularCategories/PopularCategories";
import RecentSearches from "../components/RecentSearches/RecentSearches";
import OrdersList from "../pages/OrdersList/OrdersList";
import BlogList from "../pages/Blogs/BlogList/BlogList";
import AddBlog from "../pages/Blogs/AddBlog/AddBlog";
import GSTHSN from "../pages/GST&HSN/GST-HSN";
import ProductReviews from "../pages/Manage/ProductReviews/ProductReviews";

const ProtectedRoutes = () => (
  <UseLayout>
    <Routes>
      <Route path="/dashboard" element={<Home />} />
      <Route path="manage/category" element={<CategoriesList />} />
      <Route path="manage/category/add" element={<AddCategory />} />
      <Route path="manage/category/edit/:id" element={<AddCategory />} />
      <Route path="manage/category/:id/sub-category" element={<SubCategoriesList />} />
      <Route path="manage/category/:id/sub-category/add" element={<AddSubCategory />} />
      <Route path="manage/category/:id/sub-category/edit/:subId" element={<AddSubCategory />} />
      <Route path="manage/category/:id/sub-category/:subId/layer3" element={<Layer3Category />} />
      <Route path="manage/category/:id/sub-category/:subId/layer3/add" element={<AddLayer3Category />} />
      <Route path="manage/category/:id/sub-category/:subId/layer3/edit/:subSubId" element={<AddLayer3Category />} />


      {/* <Route path="manage/categories" element={<CategoriesList />} /> */}
      <Route path="manage/products" element={<ProductList />} />
      <Route path="manage/product/add" element={<AddProducts />} />
      <Route path="manage/product/edit/:id" element={<AddProducts />} />
      <Route path="/manage-topics" element={<CustomDashboard />} />
      <Route path="/manage-topics/add" element={<AddTopic />} />
      <Route path="/manage-topics/edit/:id" element={<AddTopic />} />
      <Route path="/manage-topics/product/:id" element={<ProductTopicItems />} />
      <Route path="/manage-topics/category/:id" element={<CategoryTopicItems />} />
      <Route path="/manage-topics/advertisement/:id" element={<AddAdvertisementTopic />} />
      <Route path="/manage-topics/advertisement/:id/category" element={<CategoryTopicItems />} />
      <Route path="/manage-topics/advertisement/:id/product" element={<ProductTopicItems />} />
      <Route path="/customers" element={<CustomersList />} />
      <Route path="/trending-products" element={<TrendingProducts />} />
      <Route path="/popular-categories" element={<PopularCategories />} />
      <Route path="/recent-searches" element={<RecentSearches />} />
      <Route path="/orders" element={<OrdersList />} />
      <Route path="/manage/blogs" element={<BlogList />} />
      <Route path="/manage/addblog" element={<AddBlog />} />
      <Route path="/manage/editblog/:id" element={<AddBlog />} />
      <Route path="/gst-hsn" element={<GSTHSN /> } />
      <Route path="/manage/product-reviews" element={<ProductReviews />} />
    </Routes>
  </UseLayout>
);

const RouterComponent = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <SignInRoute>
              <Login />
            </SignInRoute>
          }
        />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <ProtectedRoutes />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterComponent;
